import { FILTER_CONSTANTS } from 'AppConstants';
import { setLocalStorage, getLocalStorage, removeLocalStorage } from '../Util';
import { BUDGET_REPORTS_CONSTANTS } from '../../budgetManagement/config';

export const handleSelected = (selectedList = {}, payload = {}) => {
    const { items = [], checked = false } = payload;
    if (!items.length) return { selectedList: {} };

    const updated = { ...selectedList };

    items.forEach((item) => {
        const id = item?.budget_id;
        if (!id) return;
        if (checked) {
            updated[id] = true; // add with true
        } else {
            delete updated[id]; // remove
        }
    });

    return { selectedList: updated };
};

export const resetBudgetFilterValues = (filters = {}) =>
    Object.fromEntries(
        Object.entries(filters).map(([key, filter]) => [
            key,
            {
                ...filter,
                value:
                    filter?.type === FILTER_CONSTANTS.DATE_FILTER
                        ? null
                        : ''
            }
        ])
    );

// Budget Reports Session Storage Utilities

/**
 * @function saveSelectedBudgetsToSession
 *
 * @author - MMT12888
 * @description - Saves selected budgets (id and name) to sessionStorage for Budget Reports page.
 * @param {Array<Object>} budgetList - Full budget list from Redux (budgetList.data).
 * @param {Object} selectedRecords - Selected budget IDs object { budget_id: true }.
 * @return {void}
 */
export const saveSelectedBudgetsToSession = (budgetList, selectedRecords) => {
    const selectedBudgetIds = Object.keys(selectedRecords);
    const selectedBudgets = budgetList
        ?.filter((budget) => selectedBudgetIds.includes(budget.budget_id))
        .map(({ budget_id, name }) => ({ budget_id, name }))
        || [];

    setLocalStorage(BUDGET_REPORTS_CONSTANTS.STORAGE_KEY, JSON.stringify(selectedBudgets), true);
};

/**
 * @function getSelectedBudgetsFromSession
 *
 * @author - MMT12888
 * @description - Retrieves selected budgets from sessionStorage for Budget Reports page.
 * @return {Array<Object>} Array of selected budget objects [{ budget_id, name }].
 */
export const getSelectedBudgetsFromSession = () => {
    const data = getLocalStorage(BUDGET_REPORTS_CONSTANTS.STORAGE_KEY, true);
    return data ? JSON.parse(data) : [];
};

/**
 * @function clearSelectedBudgetsFromSession
 *
 * @author - MMT12888
 * @description - Clears selected budgets from sessionStorage.
 * @return {void}
 */
export const clearSelectedBudgetsFromSession = () => {
    removeLocalStorage(BUDGET_REPORTS_CONSTANTS.STORAGE_KEY, true);
};